<template>
    <div class="form-group">
        <h3>Shipping Address</h3>
        <fieldset>
            <legend class="sr-only">Set shipping address</legend>
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-xs-12">
                    <div class="form-control">
                        <label for="checkoutFirstName" class="form-label">First Name</label>
                        <input v-model="first_name"
                               type="text"
                               name="shipping[first_name]"
                               id="checkoutFirstName"
                               :class="{'is-invalid': errors.has('shipping[first_name]')}"
                               v-validate="'required|max:50'"
                               data-vv-as="First Name">
                        <span class="validation-errors"
                              v-for="error in errors.collect('shipping[first_name]')">{{ error }}</span>
                    </div>
                </div>
                <div class="col-lg-6 col-sm-6 col-xs-12">
                    <div class="form-control">
                        <label for="checkoutLastName" class="form-label">Last Name</label>
                        <input v-model="last_name"
                               type="text"
                               name="shipping[last_name]"
                               id="checkoutLastName"
                               v-validate="'required|max:50'"
                               :class="{'is-invalid': errors.has('shipping[last_name]')}"
                               data-vv-as="Last Name">
                        <span class="validation-errors"
                              v-for="error in errors.collect('shipping[last_name]')">{{ error }}</span>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-control">
                        <label for="checkoutCompany" class="form-label">Company</label>
                        <input v-model="company"
                               type="text"
                               v-validate="'max:50'"
                               :class="{'is-invalid': errors.has('shipping[company]')}"
                               name="shipping[company]"
                               data-vv-as="Company"
                               id="checkoutCompany">
                        <span class="validation-errors"
                              v-for="error in errors.collect('shipping[company]')">{{ error }}</span>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-control">
                        <label for="checkoutAddress" class="form-label">Address</label>
                        <input v-model="address_line_1"
                               @change="onShippingUpdate"
                               type="text"
                               name="shipping[address_line_1]"
                               id="checkoutAddress"
                               :class="{'is-invalid': errors.has('shipping[address_line_1]')}"
                               v-validate="'required|max:50'"
                               data-vv-as="Address">
                        <span class="validation-errors"
                              v-for="error in errors.collect('shipping[address_line_1]')">{{ error }}</span>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-control">
                        <label for="checkoutAddressLine2" class="form-label">Apartment, suite,
                            etc</label>
                        <input v-model="address_line_2"
                               @change="onShippingUpdate"
                               type="text"
                               placeholder="(optional)"
                               name="shipping[address_line_2]"
                               v-validate="'max:100'"
                               :class="{'is-invalid': errors.has('shipping[address_line_2]')}"
                               id="checkoutAddressLine2"
                               data-vv-as="Apartment, suite, etc">
                        <span class="validation-errors"
                              v-for="error in errors.collect('shipping[address_line_2]')">{{ error }}</span>
                    </div>
                </div>
                <country-state :country.sync="country" :state.sync="state"></country-state>
                <div class="col-lg-6 col-sm-6 col-xs-12">
                    <div class="form-control">
                        <label for="checkoutCity" class="form-label">City</label>
                        <input v-model="city"
                               @change="onShippingUpdate"
                               type="text"
                               name="shipping[city]"
                               id="checkoutCity"
                               :class="{'is-invalid': errors.has('shipping[city]')}"
                               v-validate="'required|max:40'"
                               data-vv-as="City">
                        <span class="validation-errors"
                              v-for="error in errors.collect('shipping[city]')">{{ error }}</span>
                    </div>
                </div>
                <div class="col-lg-6 col-sm-6 col-xs-12">
                    <div class="form-control">
                        <label for="checkoutZIP" class="form-label">ZIP code</label>
                        <input v-model="zip_code"
                               @change="onShippingUpdate"
                               type="text"
                               name="shipping[zip_code]"
                               id="checkoutZIP"
                               :class="{'is-invalid': errors.has('shipping[zip_code]')}"
                               v-validate="'required|max:20'"
                               data-vv-as="ZIP code">
                        <span class="validation-errors"
                              v-for="error in errors.collect('shipping[zip_code]')">{{ error }}</span>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script>
    import Vue from 'vue';
    import countryState from "@app/components/countryState";

    export default Vue.extend({
        components: {countryState},
        name: "shipping",
        inject: ['$validator'],
        computed: {
            first_name: {
                get() {
                    return this.$store.state.shipping.first_name
                },
                set(value) {
                    this.$store.commit('shipping/setFirstName', value)
                },
                default: '',
            },
            last_name: {
                get() {
                    return this.$store.state.shipping.last_name
                },
                set(value) {
                    this.$store.commit('shipping/setLastName', value)
                },
                default: '',
            },
            company: {
                get() {
                    return this.$store.state.shipping.company
                },
                set(value) {
                    this.$store.commit('shipping/setCompany', value)
                },
                default: ''
            },
            address_line_1: {
                get() {
                    return this.$store.state.shipping.address_line_1
                },
                set(value) {
                    this.$store.commit('shipping/setAddressLine1', value)
                },
                default: ''
            },
            address_line_2: {
                get() {
                    return this.$store.state.shipping.address_line_2
                },
                set(value) {
                    this.$store.commit('shipping/setAddressLine2', value)
                },
                default: ''
            },
            city: {
                get() {
                    return this.$store.state.shipping.city
                },
                set(value) {
                    this.$store.commit('shipping/setCity', value);
                },
                default: ''
            },
            state: {
                get() {
                    return this.$store.state.shipping.state
                },
                set(value) {
                    this.$store.commit('shipping/setState', value);
                },
                default: ''
            },
            country: {
                get() {
                    return this.$store.state.shipping.country
                },
                set(value) {
                    this.$store.commit('shipping/setCountry', value);
                },
                default: ''
            },
            zip_code: {
                get() {
                    return this.$store.state.shipping.zip_code
                },
                set(value) {
                    this.$store.commit('shipping/setZipCode', value);
                },
                default: ''
            },
            loadingShippingMethods: {
                get() {
                    return this.$store.state.checkout.loadingShippingMethods;
                },
                set(value) {
                    this.$store.commit('checkout/setLoadingShippingMethods', value)
                }
            }
        },
        methods: {
            onShippingUpdate() {
                this.$emit('get-taxes');
            }
        },
    })
</script>
